import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateEvaluationCriteria from "./routes/CreateEvaluationCriteria";
import MapEvaluationCriteria from "./routes/MapEvaluationCriteria";
import EvaluationCriteriaSettings from "./routes/EvaluationCriteriaSettings";
export default store => ({
  path: "evaluation-criteria-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CreateEvaluationCriteria(store),
    MapEvaluationCriteria(store),
    EvaluationCriteriaSettings(store),
  ],
});
